var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageChangeResultBox"},[_c('el-result',{attrs:{"icon":_vm.iconTpye_data ? _vm.iconTpye_data : _vm.iconTpye,"title":_vm.title_data ? _vm.$t(_vm.title_data) : _vm.title,"subTitle":_vm.subTitle_data ? _vm.$t(_vm.subTitle_data) : _vm.subTitle}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.redirectUrl}},[_vm._v(_vm._s(_vm.$t('h.common.back')))])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-398024b5","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageChangeResult/pageChangeResult.vue
// module id = 350
// module chunks = 0